import { ElasticSearchUserResult } from 'interfaces/elasticSearchUserResult';

export interface Mention {
  label: string;
  id: string;
  communityUserId?: string;
  avatarUrl: string;
}

export const mapUserObject = (
  userData: ElasticSearchUserResult[]
): Mention[] => {
  const users = userData || [];
  return users
    .filter((userNode) => {
      const user = userNode?.node?.user;
      return user?.fullName && user?.id;
    })
    .map(({ node: mentionableUser }) => ({
      communityUserId: mentionableUser?.id,
      label: mentionableUser?.user?.fullName,
      id: mentionableUser?.user?.id,
      avatarUrl: mentionableUser?.user?.profile?.avatarUrl || '',
    }));
};
